<template>
    <basic-container>
        <!-- HVAC 套餐管理页面主容器 -->
        <div class="hvac-package-container">
            <!-- 搜索条件区域 -->
            <div class="search-container">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="套餐名称：">
                        <el-input v-model="searchForm.name" placeholder="请输入" clearable
                            @keyup.enter.native="handleSearch" style="width: 200px" />
                    </el-form-item>
                    <el-form-item label="状态：">
                        <el-select v-model="searchForm.status" placeholder="" clearable style="width: 120px">
                            <el-option label="启用" value="2" />
                            <el-option label="停用" value="1" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="text" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                        <el-button type="text" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 操作按钮区域 -->
            <div class="action-container">
                <el-button type="text" icon="el-icon-plus" @click="handleAdd">新增</el-button>
                <el-button type="text" icon="el-icon-printer" :disabled="!selectedRowKeys.length"
                    @click="handleGenerateQrCode">
                    生成二维码
                </el-button>
            </div>
            <!-- 套餐列表表格区域 -->
            <div class="table-container">
                <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange"
                    v-loading="loading" border>
                    <el-table-column type="selection" min-width="55" />
                    <el-table-column prop="name" label="套餐名称" min-width="180">
                        <template slot-scope="scope">
                            <span class="package-name-link" @click="handleViewPackageDetail(scope.row)">
                                {{ scope.row.name }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" min-width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === 1" type="danger">停用</el-tag>
                            <el-tag v-else type="success">启用</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createBy" label="创建人" min-width="100" />
                    <el-table-column prop="createTime" label="创建时间" min-width="180" />
                    <el-table-column label="操作" min-width="200" align="center">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status === 2" type="text" icon="el-icon-close" size="mini"
                                @click="handleDisable(scope.row)">
                                停用
                            </el-button>
                            <el-button v-else type="text" icon="el-icon-check" size="mini"
                                @click="handleEnable(scope.row)">
                                启用
                            </el-button>
                            <el-button type="text" icon="el-icon-edit" size="mini"
                                @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button type="text" icon="el-icon-delete" size="mini"
                                @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分页组件区域 -->
            <div class="pagination-container">
                <el-pagination background layout="prev, pager, next, jumper" :total="total"
                    :current-page.sync="currentPage" :page-size.sync="pageSize" @current-change="handleCurrentChange" />
            </div>
            <!-- 查看详情弹窗 - 显示套餐的只读信息 -->
            <el-dialog title="套餐详情" :visible.sync="detailDialogVisible" min-width="50%" :close-on-click-modal="false">
                <el-form :model="currentPackage" label-width="120px">
                    <el-form-item label="套餐名称">
                        <el-input v-model="currentPackage.name" disabled />
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-input :value="currentPackage.status === 1 ? '停用' : '启用'" disabled />
                    </el-form-item>
                    <el-form-item label="创建人">
                        <el-input v-model="currentPackage.createBy" disabled />
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-input v-model="currentPackage.createTime" disabled />
                    </el-form-item>
                    <!-- 其他详情字段 -->
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="text" icon="el-icon-close" @click="detailDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>
            <!-- 编辑弹窗 - 用于修改现有套餐信息 -->
            <el-dialog title="编辑套餐" :visible.sync="editDialogVisible" min-width="50%" :close-on-click-modal="false"
                @close="handleEditDialogClose">
                <el-form :model="editForm" :rules="rules" ref="editFormRef" label-width="120px">
                    <el-form-item label="套餐名称" prop="name">
                        <el-input v-model="editForm.name" maxlength="50" show-word-limit />
                    </el-form-item>
                    <!-- 套餐/VR切换标签页 -->
                    <el-form-item>
                        <el-radio-group v-model="editForm.type" class="switch-type">
                            <el-radio-button label="package">套餐</el-radio-button>
                            <el-radio-button label="vr">VR</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <!-- 套餐类型内容 -->
                    <template v-if="editForm.type === 'package'">
                        <!-- <el-form-item label="上传文件">
                            <FileUpload :multiple="true" :limit="9" :uploaded-files="editForm.files"
                                @uploaded="handleFileUpload('edit', $event)" />
                        </el-form-item> -->
                        <div class="form-item">
                            <div class="label-with-tip">
                                <label>上传</label>
                                <div class="text-tips">(支持图片)</div>
                            </div>
                            <FileUpload :multiple="true" :limit="9" :uploaded-files="editForm.files"
                                @uploaded="handleFileUpload('edit', $event)" @uploading="handleUploading" />
                        </div>
                        <!-- 文件表格展示 -->
                        <el-form-item v-if="editForm.files && editForm.files.length > 0">
                            <el-table :data="editForm.files" style="width: 100%" border>
                                <el-table-column prop="fileName" label="文件名/导入类型" min-width="200"></el-table-column>
                                <el-table-column prop="sort" label="排列顺序" min-width="120">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.sort" :min="1" :step="1"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" min-width="100">
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="mini"
                                            @click="handleDeleteEditFile(scope.row, scope.$index)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </template>
                    <!-- VR类型内容 -->
                    <template v-else-if="editForm.type === 'vr'">
                        <el-form-item label="VR地址" prop="vrUrl">
                            <el-input v-model="editForm.vrUrl" placeholder="请输入VR地址" />
                        </el-form-item>
                    </template>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="text" icon="el-icon-circle-close" @click="handleEditDialogClose">取消</el-button>
                    <el-button type="text" icon="el-icon-circle-check" @click="submitEdit" :disabled="uploading">确定</el-button>
                </span>
            </el-dialog>
            <!-- 新增弹窗 - 用于创建新的套餐或VR -->
            <el-dialog title="新增内容" :visible.sync="addDialogVisible" min-width="60%" :close-on-click-modal="false"
                @close="handleAddDialogClose">
                <el-form :model="addForm" :rules="rules" ref="addFormRef" label-width="120px">
                    <el-form-item label="套餐名称" prop="name">
                        <el-input v-model="addForm.name" maxlength="50" show-word-limit />
                    </el-form-item>
                    <!-- 套餐/VR切换标签页 -->
                    <el-form-item>
                        <el-radio-group v-model="addForm.type" class="switch-type">
                            <el-radio-button label="package">套餐</el-radio-button>
                            <el-radio-button label="vr">VR</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <!-- 套餐类型内容 -->
                    <template v-if="addForm.type === 'package'">
                        <div class="form-item">
                            <div class="label-with-tip">
                                <label>上传</label>
                                <div class="text-tips">(支持图片)</div>
                            </div>
                            <FileUpload :multiple="true" :limit="9" :uploaded-files="addForm.files"
                                @uploaded="handleFileUpload('add', $event)" @uploading="handleUploading" />
                        </div>
                        <!-- 文件表格展示 -->
                        <el-form-item v-if="addForm.files.length > 0">
                            <el-table :data="addForm.files" style="width: 100%" border>
                                <el-table-column prop="fileName" label="文件名/导入类型" min-width="200"></el-table-column>
                                <el-table-column prop="sort" label="排列顺序" min-width="120">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.sort" :min="1" :step="1"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" min-width="100">
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="mini"
                                            @click="handleDeleteFile(scope.row, scope.$index)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </template>
                    <!-- VR类型内容 -->
                    <template v-else-if="addForm.type === 'vr'">
                        <el-form-item label="VR地址" prop="vrUrl">
                            <el-input v-model="addForm.vrUrl" placeholder="请输入VR地址" />
                        </el-form-item>
                    </template>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="text" icon="el-icon-circle-close" @click="handleAddDialogClose">取消</el-button>
                    <el-button type="text" icon="el-icon-circle-check" @click="submitAdd" :disabled="uploading">确定</el-button>
                </span>
            </el-dialog>
            <!-- 生成二维码弹窗 - 显示选中套餐的二维码 -->
            <el-dialog title="生成二维码" :visible.sync="qrCodeDialogVisible" min-width="400px" :close-on-click-modal="false"
                @close="handleQrCodeDialogClose">
                <el-form :model="{ qrCodeName }" :rules="qrCodeRules" ref="qrCodeFormRef" label-width="180px">
                    <el-form-item label="二维码名称" prop="qrCodeName">
                        <el-input v-model="qrCodeName" placeholder="请输入二维码名称" maxlength="50" show-word-limit />
                    </el-form-item>
                </el-form>
                <div class="qr-code-container" v-if="qrCodeUrl">
                    <img :src="qrCodeUrl" alt="二维码" class="qr-code-image" />
                    <p class="qr-code-tip">微信扫码查看最新套餐内容</p>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="text" icon="el-icon-close" @click="handleQrCodeDialogClose">关闭</el-button>
                    <el-button type="text" icon="el-icon-check" @click="handleGenerateQrCodeConfirm">生成二维码</el-button>
                </span>
            </el-dialog>
        </div>
    </basic-container>
</template>
<script>
import {
    getHvacPackageList,
    getHvacPackageDetail,
    addHvacPackage,
    editHvacPackage,
    deleteHvacPackage,
    enableHvacPackage,
    disableHvacPackage,
    generateHvacPackageQrCode
} from '@/api/salesCloud/hvacPackage'
import FileUpload from './components/fileUpload'
// HVAC 套餐管理组件
export default {
    name: 'HvacPackage',
    components: {
        FileUpload
    },
    // 组件数据
    data() {
        return {
            searchForm: {
                name: '',
                status: ''
            },
            tableData: [],
            loading: false,
            total: 0,
            currentPage: 1,
            pageSize: 10,
            selectedRowKeys: [],
            selectedRows: [],
            detailDialogVisible: false,
            editDialogVisible: false,
            addDialogVisible: false,
            qrCodeDialogVisible: false,
            currentPackage: {},
            uploading: false, // 添加上传状态变量
            editForm: {
                name: '',
                images: [],
                type: 'package', // 'package' 或 'vr'
                files: [], // 用于存储导入的文件列表
                vrUrl: '' // VR地址
            },
            addForm: {
                name: '',
                images: [],
                type: 'package', // 'package' 或 'vr'
                files: [], // 用于存储导入的文件列表
                vrUrl: '' // VR地址
            },
            qrCodeUrl: '',
            qrCodeName: '二维码', // 二维码名称
            rules: {
                name: [
                    { required: true, message: '请输入套餐名称', trigger: 'blur' },
                    { max: 50, message: '套餐名称不能超过50个字符', trigger: 'blur' }
                ],
                vrUrl: [
                    { required: false, validator: this.validateVrUrl, trigger: ['blur', 'change'] }
                ],
                files: [
                    { required: false, validator: this.validateFiles, trigger: 'change' }
                ]
            },
            qrCodeRules: {
                qrCodeName: [
                    { required: true, message: '请输入二维码名称', trigger: 'blur' },
                    { max: 50, message: '二维码名称不能超过50个字符', trigger: 'blur' }
                ]
            },
        }
    },
    created() {
        this.loadData()
    },
    /**
         * 组件方法集合
         */
    methods: {
        handleEditDialogClose() {
            this.editDialogVisible = false
        },
        /**
         * 处理二维码弹窗关闭
         * @description 关闭二维码弹窗并重置二维码名称
         */
        handleQrCodeDialogClose() {
            this.qrCodeDialogVisible = false
            this.qrCodeName = '二维码' // 重置为默认值
        },
        /**
         * 处理新增弹窗关闭
         * @description 关闭新增弹窗并重置所有表单数据和状态
         */
        handleAddDialogClose() {
            // 完全重置表单数据
            this.addForm = {
                name: '',
                images: [],
                type: 'package',
                files: [],
                vrUrl: ''
            }
            // 如果表单引用存在，重置验证状态
            if (this.$refs.addFormRef) {
                this.$refs.addFormRef.resetFields()
            }
            // 关闭弹窗
            this.addDialogVisible = false
        },
        /**
         * 打开二维码弹窗
         * @description 打开展示二维码的弹窗
         */
        handleGenerateQrCode() {
            this.qrCodeUrl = '' // 清空之前的二维码
            this.qrCodeDialogVisible = true
        },
        /**
         * 确认生成二维码
         * @description 验证二维码名称并生成二维码
         * @returns {Promise<void>}
         */
        async handleGenerateQrCodeConfirm() {
            // 验证二维码名称
            const valid = await this.$refs.qrCodeFormRef.validate();
            if (valid) {
                try {
                    // 构建请求数据结构
                    const params = {
                        name: this.qrCodeName,
                        comboList: this.selectedRows.map(row => ({ comboId: row.id }))
                    };
                    const res = await generateHvacPackageQrCode(params)
                    if (res.code == 200) {
                        this.$message.success('二维码生成成功')
                        this.qrCodeDialogVisible = false
                    } else {
                        this.$message.error(res.msg || '生成二维码失败')
                    }
                } catch (error) {
                    this.$message.error('生成二维码失败')
                }
            }
        },
        /**
         * 处理上传状态变化
         */
        handleUploading(status) {
            this.uploading = status;
        },
        /**
         * 验证VR地址
         */
        validateVrUrl(rule, value, callback) {
            // 只有在VR类型且没有输入VR地址时才验证
            if (this.addForm.type === 'vr' && (!value || value.trim() === '')) {
                callback(new Error('请输入VR地址'))
            } else {
                callback()
            }
        },
        /**
         * 验证文件列表
         */
        validateFiles(rule, value, callback) {
            // 对于套餐类型，可以有图片或PDF文件，至少需要一种
            if (this.addForm.type === 'package' && this.addForm.files.length === 0) {
                callback(new Error('请至少上传一张图片或一个PDF文件'))
            } else {
                callback()
            }
        },
        /**
         * 加载套餐列表数据
         * @description 根据搜索条件和分页信息从服务器获取套餐列表
         * @returns {Promise<void>}
         */
        async loadData() {
            this.loading = true
            try {
                const params = {
                    page: this.currentPage,
                    size: this.pageSize,
                    name: this.searchForm.name,
                    status: this.searchForm.status
                }
                const res = await getHvacPackageList(params)
                this.tableData = JSON.parse(res.data).rows
                this.total = JSON.parse(res.data).total
            } catch (error) {
                this.$message.error('获取套餐列表失败')
            } finally {
                this.loading = false
            }
        },
        /**
           * 处理搜索操作
           * @description 根据当前搜索条件重新加载数据，重置为第一页
           */
        handleSearch() {
            this.currentPage = 1
            this.loadData()
        },
        /**
           * 重置搜索条件
           * @description 清空所有搜索条件并重新加载数据
           */
        resetSearch() {
            this.searchForm = {
                name: '',
                status: ''
            }
            this.currentPage = 1
            this.loadData()
        },
        /**
           * 处理分页变化
           * @description 当用户切换页码时触发，加载对应页的数据
           * @param {number} currentPage - 当前页码
           */
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.loadData()
        },
        /**
           * 处理表格复选框选择变化
           * @description 更新选中的行数据和行ID数组
           * @param {Array} selection - 选中的行数据数组
           */
        handleSelectionChange(selection) {
            this.selectedRowKeys = selection.map(row => row.id)
            this.selectedRows = selection
        },
        /**
           * 查看套餐详情
           * @description 点击套餐名称时触发，获取并显示套餐的详细信息
           * @param {Object} row - 选中的套餐行数据
           * @returns {Promise<void>}
           */
        async handleViewPackageDetail(row) {
            try {
                const res = await getHvacPackageDetail(row.id)
                this.currentPackage = JSON.parse(res.data)
                this.detailDialogVisible = true
            } catch (error) {
                this.$message.error('获取套餐详情失败')
            }
        },
        /**
           * 启用套餐
           * @description 将套餐状态从停用改为启用
           * @param {Object} row - 要启用的套餐行数据
           * @returns {Promise<void>}
           */
        async handleEnable(row) {
            this.$confirm('确定要启用该套餐吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const params = {
                        id: row.id,
                        status: 2
                    }
                    await enableHvacPackage(params)
                    this.$message({
                        type: 'success',
                        message: '启用成功'
                    })
                    // 刷新当前页数据
                    this.loadData()
                } catch (error) {
                    this.$message.error('启用失败')
                }
            }).catch(() => { })
        },
        /**
           * 停用套餐
           * @description 将套餐状态从启用改为停用
           * @param {Object} row - 要停用的套餐行数据
           * @returns {Promise<void>}
           */
        async handleDisable(row) {
            this.$confirm('确定要停用该套餐吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const params = {
                        id: row.id,
                        status: 1
                    }
                    await disableHvacPackage(params)
                    this.$message({
                        type: 'success',
                        message: '停用成功'
                    })
                    // 刷新当前页数据
                    this.loadData()
                } catch (error) {
                    this.$message.error('停用失败')
                }
            }).catch(() => { })
        },
        /**
             * 处理文件上传
             * @description 接收上传组件返回的文件列表并更新表单数据
             * @param {string} type - 表单类型 ('add' 或 'edit')
             * @param {Array} files - 上传的文件列表
             */
        handleFileUpload(type, files) {
            if (type === 'add') {
                // 更新文件列表
                this.addForm.files = files;
                // 同时更新图片列表（为了兼容原有逻辑）
                this.addForm.images = files
                    .filter(file => file.fileType === 'image')
                    .map(file => file.url);
            } else if (type === 'edit') {
                // 更新编辑表单的文件列表
                this.editForm.files = files;
                // 同时更新图片列表（为了兼容原有逻辑）
                this.editForm.images = files
                    .filter(file => file.fileType === 'image')
                    .map(file => file.url);
            }
        },
        /**
         * 从URL获取文件名
         */
        getFileNameFromUrl(url) {
            // 从URL中提取文件名
            const match = url.match(/[^/]+\.\w+$/i);
            return match ? match[0] : 'file';
        },
        /**
         * 删除文件
         */
        handleDeleteFile(file, index) {
            this.$confirm('确定要删除该文件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 从文件列表中删除
                this.addForm.files.splice(index, 1);
                // 如果是图片文件，同时从images数组中删除
                if (file.fileType === 'image' && file.url) {
                    const imageIndex = this.addForm.images.indexOf(file.url);
                    if (imageIndex > -1) {
                        this.addForm.images.splice(imageIndex, 1);
                    }
                }
                this.$message.success('删除成功');
            }).catch(() => { });
        },
        /**
         * 删除编辑表单中的文件
         */
        handleDeleteEditFile(file, index) {
            this.$confirm('确定要删除该文件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 从文件列表中删除
                this.editForm.files.splice(index, 1);
                // 如果是图片文件，同时从images数组中删除
                if (file.fileType === 'image' && file.url) {
                    const imageIndex = this.editForm.images.indexOf(file.url);
                    if (imageIndex > -1) {
                        this.editForm.images.splice(imageIndex, 1);
                    }
                }
                this.$message.success('删除成功');
            }).catch(() => { });
        },
        /**
         * 编辑套餐
         * @description 打开编辑弹窗并填充当前套餐数据
         * @param {Object} row - 要编辑的套餐行数据
         */
        handleEdit(row) {
            // 获取套餐详情，确保包含图片信息
            this.getPackageDetailForEdit(row.id);
        },
        /**
         * 获取套餐详情用于编辑
         * @description 获取套餐详情并处理图片数据
         * @param {number} id - 套餐ID
         */
        async getPackageDetailForEdit(id) {
            try {
                const res = await getHvacPackageDetail(id);
                const detail = JSON.parse(res.data);
                console.log('index.vue ~ line: 528 ~ detail ->', detail);
                // 确保图片字段是数组格式
                detail.images = detail.images || [];
                if (typeof detail.images === 'string') {
                    detail.images = detail.images.includes(',') ? detail.images.split(',') : [detail.images];
                }
                // 初始化文件列表
                detail.files = detail.files || [];
                if (Array.isArray(detail.fileList)) {
                    // 处理从后端返回的fileList格式
                    detail.files = detail.fileList.map((file, index) => {
                        const fileName = this.getFileNameFromUrl(file.url);
                        const fileExtension = fileName.split('.').pop().toLowerCase();
                        const fileType = ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension) ? 'image' :
                            fileExtension === 'pdf' ? 'pdf' : 'other';
                        return {
                            ...file,
                            fileName,
                            fileType,
                            url: file.url,
                            sort: file.sort || (index + 1)
                        };
                    });
                }
                this.editForm = { ...detail };
                this.editDialogVisible = true;
                this.editForm.type = this.editForm.type == '1' ? 'package' : 'vr';
                //初始化套餐/VR类型的特殊字段
                if (this.editForm.type === 'vr') {
                    this.editForm.vrUrl = this.editForm.fileList[0] ? this.editForm.fileList[0].url : '';
                    this.editForm.fileList = [];
                    this.editForm.images = [];
                    this.editForm.files = [];
                }
            } catch (error) {
                this.$message.error('获取套餐详情失败');
            }
        },
        /**
         * 新增套餐
         * @description 打开新增弹窗并重置表单
         */
        handleAdd() {
            this.addForm = {
                name: '',
                images: [],
                type: 'package',
                files: [],
                vrUrl: ''
            };
            this.addDialogVisible = true;
        },
        /**
           * 提交编辑
           * @description 验证表单并提交编辑后的套餐数据
           * @returns {Promise<void>}
           */
        async submitEdit() {
            this.$refs.editFormRef.validate(async (valid) => {
                if (valid) {
                    try {
                        // 按照指定的数据结构处理提交数据
                        const submitData = {
                            ...this.editForm,
                            type: this.editForm.type === 'package' ? '1' : '2',
                        };
                        // 处理VR类型的特殊字段
                        if (this.editForm.type === 'vr') {
                            // VR类型：将VR地址构造到fileList数组中，vrUrl置空
                            submitData.fileList = [{ url: this.editForm.vrUrl, fileName: 'VR地址', sort: 1 }];
                            submitData.vrUrl = '';
                        } else {
                            // 套餐类型：处理文件列表，vrUrl置空
                            submitData.vrUrl = '';
                            if (this.editForm.files && this.editForm.files.length > 0) {
                                // 确保保留后台返回的原始数据，同时处理新增的文件
                                submitData.fileList = this.editForm.files.map(file => {
                                    // 如果是有id的文件（从后端返回的），保留所有原始字段
                                    // 如果是新增的文件，按照新增时的格式构造
                                    return {
                                        ...file, // 保留原始所有字段
                                        comboId: submitData.id || '',
                                    };
                                });
                            }
                        }
                        // submitData 结构
                        await editHvacPackage(submitData);
                        this.$message.success('编辑成功');
                        this.editDialogVisible = false;
                        this.loadData();
                    } catch (error) {
                        this.$message.error('编辑失败');
                    }
                }
            });
        },
        /**
           * 提交新增
           * @description 验证表单并提交新增的套餐数据
           * @returns {Promise<void>}
           */
        async submitAdd() {
            this.$refs.addFormRef.validate(async (valid) => {
                if (valid) {
                    try {
                        // 根据类型处理数据
                        const submitData = { ...this.addForm };
                        /* // 如果是套餐类型，确保文件列表排序正确
                        if (submitData.type === 'package') {
                            // 对文件列表按排序号排序
                            submitData.files.sort((a, b) => (a.sort || 0) - (b.sort || 0));
                            // 将文件信息转换为适合后端的格式
                            // 实际项目中可能需要根据后端API要求进行调整
                        } */
                        //    不区分文件类型，直接转换为字符串
                        const params = {
                            name: submitData.name,
                            type: submitData.type === 'package' ? '1' : '2',
                            fileList: submitData.type === 'vr'
                                ? [{ url: submitData.vrUrl, fileName: 'VR地址', sort: 1 }] // VR类型时构造fileList
                                : submitData.files.map(file => ({
                                    ...file,
                                    url: file.url,
                                    sort: file.sort
                                })),
                            vrUrl: '' // 统一将vrUrl置空，通过fileList传递数据
                        }
                        await addHvacPackage(params)
                        this.$message({
                            type: 'success',
                            message: '新增成功'
                        })
                        this.addDialogVisible = false
                        this.loadData()
                    } catch (error) {
                        this.$message.error('新增失败')
                    }
                }
            })
        },
        /**
           * 删除套餐
           * @description 确认后删除指定的套餐
           * @param {Object} row - 要删除的套餐行数据
           * @returns {Promise<void>}
           */
        async handleDelete(row) {
            this.$confirm('确定要删除该套餐吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    await deleteHvacPackage(row.id)
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    })
                    this.loadData()
                } catch (error) {
                    this.$message.error('删除失败')
                }
            }).catch(() => { })
        },
        /**
           * 处理编辑弹窗关闭
           * @description 关闭编辑弹窗并重置表单数据
           */
    },
}
</script>
<style scoped>
.hvac-package-container {
    padding: 20px;
    background-color: #fff;
}

/* 操作按钮区域样式 */
.action-container {
    margin: 10px 0;
    border-radius: 4px;
    display: flex;
    gap: 10px;
    align-items: center;
}

/* 按钮样式增强 */
:deep(.action-container .el-button) {
    margin-right: 10px;
}

.search-container {
    padding: 10px;
    border-radius: 4px;
}

.table-container {
    margin-bottom: 20px;
}

.switch-type {
    margin-bottom: 20px;
    border-bottom: 1px solid #e4e7ed;
}

.switch-type>>>.el-radio-group {
    display: inline-flex;
}

.switch-type>>>.el-radio-button:first-child .el-radio-button__inner {
    border-radius: 4px 0 0 4px;
}

.switch-type>>>.el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 4px 4px 0;
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.package-name-link {
    color: #409EFF;
    cursor: pointer;
}

.package-name-link:hover {
    text-decoration: underline;
}

.qr-code-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
}

.qr-code-image {
    width: 200px;
    height: 200px;
    margin-bottom: 20px;
}

.qr-code-tip {
    text-align: center;
    color: #606266;
}

.form-item {
    margin-left: 50px;
    display: flex;
}

.label-with-tip {
    margin-bottom: 4px;
    width: 100px;
}

.label-with-tip label {
    font-weight: 500;
    color: #606266;
}

.text-tips {
    font-size: 12px;
    color: #909399;
    margin-top: 2px;
    line-height: 1.2;
}
</style>